import type { Messages } from './en';

export const es: Messages = {
  'nav.clientHub': 'Portal de Clientes',
  'nav.menu': 'Menú',
  'nav.home': 'Inicio',
  'nav.products': 'Productos',
  'nav.liveCasino': 'Casino en vivo',
  'nav.slots': 'Slots',
  'nav.tableGames': 'Juegos de mesa',
  'nav.library': 'Biblioteca',
  'nav.roadmap': 'Hoja de ruta',
  'nav.assets': 'Recursos',
  'nav.guidelines': 'Directrices',
  'nav.account': 'Cuenta',
  'nav.signOut': 'Cerrar sesión',
  'nav.categoriesAria': 'Categorías de juegos',
  'nav.sectionsAria': 'Secciones principales',
  'nav.brandAria': 'RichyPlay Portal de Clientes',
  'nav.comingSoon': 'Próximamente',
  'nav.soon': 'Pronto',

  'lang.label': 'Idioma',
  'lang.select': 'Seleccionar idioma',

  'category.live': 'En vivo',
  'category.slot': 'Tragamonedas',
  'category.instant': 'Instantáneos',
  'category.table': 'Mesa',

  'status.planned': 'Planificado',
  'status.in_progress': 'En curso',
  'status.shipped': 'Publicado',
  'status.available': 'Disponible',
  'status.coming_soon': 'Próximamente',
  'status.maintenance': 'Mantenimiento',

  'common.error': 'Algo salió mal',
  'common.checkingSession': 'Comprobando la sesión…',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.none': 'Ninguno',
  'common.active': 'Activo',
  'common.inactive': 'Inactivo',

  'home.eyebrow': 'Portal del operador',
  'home.title': 'Portal de Clientes',
  'home.lead':
    'Explora el catálogo de RichyPlay: lanza demos, sigue la hoja de ruta y descarga recursos de marca desde un único espacio de trabajo.',
  'home.enterLibrary': 'Entrar en la biblioteca',
  'home.viewRoadmap': 'Ver hoja de ruta',
  'home.browse': 'Explorar por categoría',
  'home.openLibrary': 'Abrir biblioteca',

  'library.eyebrow': 'Biblioteca de juegos',
  'library.title': 'Catálogo',
  'library.liveTitle': 'Portafolio de casino en vivo',
  'library.slotTitle': 'Portafolio de slots',
  'library.liveLead': 'Elige un producto en vivo. Blackjack y Roulette están activos; el resto llega pronto.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': 'Busca y filtra el catálogo de RichyPlay. Lanza demos en una pestaña nueva.',
  'library.search': 'Buscar juegos…',
  'library.statusFilterAria': 'Filtrar por estado',
  'library.statusAll': 'Todos los estados',
  'library.loading': 'Cargando juegos…',
  'library.unavailableTitle': 'Biblioteca no disponible',
  'library.unavailableMessage':
    'No se pudo cargar la biblioteca de juegos. Es posible que el catálogo no esté disponible.',
  'library.apiFailedMessage':
    'No pudimos conectar con la API del catálogo. Inténtalo más tarde o contacta con soporte.',
  'library.emptyTitle': 'No se encontraron juegos',
  'library.emptyMessage': 'Prueba con otra búsqueda o filtro de categoría.',
  'library.viewGame': 'Ver juego',

  'game.loading': 'Cargando juego…',
  'game.notFound': 'Juego no encontrado.',
  'game.back': 'Volver',
  'game.breadcrumbAria': 'Ruta de navegación',
  'game.liveCasino': 'Casino en vivo',
  'game.slots': 'Tragamonedas',
  'game.demoFrameTitle': 'Demo de {title}',
  'game.startingDemo': 'Iniciando sesión de demo…',
  'game.demoNotStarted': 'No se pudo iniciar la sesión de demo.',
  'game.demoBadge': 'Modo demo',
  'game.blockedMaintenance': 'Este juego está en mantenimiento.',
  'game.blockedComingSoon': 'Próximamente: la demo aún no está publicada.',
  'game.blockedNoDemo': 'El catálogo del operador no ofrece una versión demo de este título.',
  'game.currency': 'Moneda',
  'game.language': 'Idioma',
  'game.reloadDemo': 'Recargar demo',
  'game.startDemo': 'Iniciar demo',
  'game.openNewTab': 'Abrir en una pestaña nueva',
  'game.copyLink': 'Copiar enlace',
  'game.copied': 'Copiado',
  'game.demoFailedTitle': 'Error al iniciar la demo',
  'game.demoUrlMissing': 'El servidor no devolvió la URL de lanzamiento.',
  'game.demoFailed': 'No se pudo iniciar la demo.',
  'game.highlighted': 'Destacado',
  'game.features': 'Funciones del juego',
  'game.keyFeatures': 'Características clave',
  'liveTable.title': 'Mesas disponibles',
  'liveTable.totalResults': 'Resultados totales:',
  'liveTable.download': 'Descargar datos de mesa',
  'liveTable.gameId': 'ID del juego',
  'liveTable.tableName': 'Nombre de la mesa',
  'liveTable.minLimit': 'Límite mínimo',
  'liveTable.maxLimit': 'Límite máximo',
  'liveTable.hours': 'Horario de operación UTC',
  'liveTable.language': 'Idioma de operación',
  'liveTable.releaseDate': 'Fecha de lanzamiento',
  'liveTable.location': 'Ubicación',
  'game.betLevels': 'Niveles de apuesta',
  'game.tableRules': 'Reglas de la mesa',
  'game.mathConfig': 'Configuración matemática',
  'game.resources': 'Recursos',
  'game.relatedAssets': 'Recursos relacionados',
  'game.releaseRoadmap': 'Hoja de ruta de lanzamientos',
  'game.integrationGuidelines': 'Directrices de integración',
  'game.information': 'Información del juego',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Escritorio',
  'game.platformTablet': 'Tablet',
  'game.platformMobile': 'Móvil',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'La ficha de datos del juego se añadirá pronto.',

  'spec.numericId': 'ID numérico',
  'spec.minBetPerLine': 'Apuesta mínima por línea',
  'spec.minTotalBet': 'Apuesta total mínima',
  'spec.maxTotalBet': 'Apuesta total máxima',
  'spec.maxTotalBetAnte': 'Apuesta total máxima con Ante',
  'spec.reels': 'Rodillos',
  'spec.rows': 'Filas',
  'spec.payType': 'Tipo de pago',
  'spec.payLinesValue': '{count} líneas',
  'spec.symbolPays': 'Pagos por símbolo',
  'spec.betMultiplier': 'Multiplicador de apuesta',
  'spec.maxMultiplierWin': 'Ganancia máx. por multiplicador',
  'spec.maxExposure': 'Exposición máxima',
  'spec.bonusBuyX': 'Compra de bonus X',
  'spec.anteBetX': 'Apuesta Ante X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': 'Frecuencia de premios',
  'spec.oneIn': '1 de cada {value}',
  'spec.hasReplay': 'Repetición',
  'spec.hasBuySpins': 'Compra de giros',
  'spec.hasInstantBonus': 'Bonus instantáneo',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Apuesta Ante',
  'spec.releaseDate': 'Fecha de lanzamiento',
  'spec.symbol': 'Símbolo del juego',
  'spec.referenceId': 'ID de referencia',
  'spec.provider': 'Proveedor',
  'spec.product': 'Producto',
  'spec.gameType': 'Tipo de juego',
  'spec.category': 'Categoría',
  'spec.theme': 'Temática',
  'spec.technology': 'Tecnología',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Volatilidad',
  'spec.maxWin': 'Ganancia máxima',
  'spec.paylines': 'Líneas de pago',
  'spec.grid': 'Cuadrícula',
  'spec.bonusFrequency': 'Frecuencia de bonus',
  'spec.bonusFrequencyValue': '1 de cada {value}',
  'spec.jackpot': 'Bote',
  'spec.betRange': 'Rango de apuesta',
  'spec.defaultBet': 'Apuesta por defecto',
  'spec.currency': 'Moneda',
  'spec.languages': 'Idiomas',
  'spec.demoAvailable': 'Demo disponible',
  'spec.tournaments': 'Torneos',
  'spec.highlighted': 'Destacado',
  'spec.status': 'Estado',
  'spec.version': 'Versión',
  'spec.lastUpdated': 'Última actualización',

  'roadmap.eyebrow': 'Hoja de ruta del producto',
  'roadmap.title': 'Qué viene',
  'roadmap.lead': 'Sigue los próximos lanzamientos y los títulos publicados por categoría.',
  'roadmap.bannerAria': 'Próximos lanzamientos',
  'roadmap.soonTitle': 'Próximamente',
  'roadmap.loading': 'Cargando hoja de ruta…',
  'roadmap.error': 'No se pudieron cargar los elementos de la hoja de ruta.',
  'roadmap.emptyTitle': 'Sin elementos en la hoja de ruta',
  'roadmap.emptyMessage': 'Todavía no hay entradas publicadas para esta categoría.',
  'roadmap.itemCount': '{count} elementos',
  'roadmap.target': 'Objetivo: {date}',
  'roadmap.viewInLibrary': 'Ver en la biblioteca',

  'upcoming.title': 'Próximos lanzamientos',
  'upcoming.playDemo': 'Jugar demo',
  'upcoming.prev': 'Lanzamientos anteriores',
  'upcoming.next': 'Siguientes lanzamientos',

  'assets.eyebrow': 'Recursos de marca',
  'assets.title': 'Paquetes de recursos',
  'assets.lead':
    'Descarga logotipos, ilustraciones y materiales de marketing. Consulta {link} para las normas de uso.',
  'assets.leadLink': 'las directrices de recursos',
  'assets.loading': 'Cargando recursos…',
  'assets.error': 'No se pudieron cargar los paquetes de recursos.',
  'assets.downloadFailed': 'Error en la descarga.',
  'assets.emptyTitle': 'Aún no hay recursos',
  'assets.emptyForGame': 'No hay paquetes de recursos vinculados a este juego.',
  'assets.emptyGeneral': 'Los paquetes de recursos aparecerán aquí cuando se publiquen.',
  'assets.pack': 'Paquete',
  'assets.updated': 'Actualizado {date}',
  'assets.download': 'Descargar',
  'assets.search': 'Buscar por nombre de juego…',
  'assets.searchEmpty': 'Ningún juego coincide con ese nombre.',

  'guidelines.eyebrow': 'Documentación',
  'guidelines.title': 'Directrices',
  'guidelines.lead': 'Notas de integración, uso de recursos y referencias para operadores.',
  'guidelines.all': 'Todas',
  'guidelines.integration': 'Integración',
  'guidelines.assets': 'Recursos',
  'guidelines.loading': 'Cargando directrices…',
  'guidelines.error': 'No se pudieron cargar las directrices.',
  'guidelines.emptyTitle': 'Sin directrices',
  'guidelines.emptyMessage': 'Las directrices publicadas aparecerán aquí.',
  'guidelines.index': 'Índice',
  'guidelines.navAria': 'Navegación de directrices',
  'guidelines.articleLoading': 'Cargando artículo…',
  'guidelines.notFound': 'Directriz no encontrada.',
  'guidelines.notFoundShort': 'No encontrado',
  'guidelines.updated': 'Actualizado {date}',
  'guidelines.external': 'El contenido está alojado externamente.',
  'guidelines.openDocument': 'Abrir documento',
  'guidelines.typeGuide': 'Guía',
  'guidelines.typeGuideline': 'Directriz',

  'account.eyebrow': 'Tu cuenta',
  'account.title': 'Perfil',
  'account.email': 'Correo electrónico',
  'account.language': 'Idioma de la interfaz',
  'account.recentActivity': 'Actividad reciente',
  'account.loadingActivity': 'Cargando actividad…',
  'account.activityUnavailable': 'La actividad reciente no está disponible en este momento.',
  'account.noActivity': 'No hay actividad reciente registrada.',

  'event.login': 'Sesión iniciada',
  'event.logout': 'Sesión cerrada',
  'event.libraryView': 'Biblioteca vista',
  'event.gameView': 'Juego visto',
  'event.demoLaunch': 'Demo iniciada',
  'event.demoLaunchFailed': 'Error al iniciar la demo',
  'event.assetDownload': 'Recurso descargado',
  'event.guidelineView': 'Directriz vista',
  'event.roadmapView': 'Hoja de ruta vista',

  'auth.title': 'Portal de Clientes',
  'auth.subtitle': 'Inicia sesión con tus credenciales de operador',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.rememberMe': 'Recordarme',
  'auth.signIn': 'Iniciar sesión',
  'auth.signInFailed': 'Error al iniciar sesión',
  'auth.signInError': 'No se pudo iniciar sesión. Revisa tus credenciales e inténtalo de nuevo.',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.inviteOnly': 'Acceso solo por invitación. Contacta con tu representante de RichyPlay.',
  'auth.visitSiteAria': 'Ir a richyplay.live',

  'footer.navAria': 'Pie de página',
  'footer.tagline': 'Portal de operadores para el catálogo de slots y casino en vivo de RichyPlay.',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.legal': 'Acceso por invitación para operadores con licencia. Solo para uso profesional.',

  'forgot.eyebrow': 'Restablecer contraseña',
  'forgot.title': 'Contraseña olvidada',
  'forgot.requestSubtitle':
    'Introduce tu correo electrónico y te enviaremos un código de verificación si existe una cuenta.',
  'forgot.sendCode': 'Enviar código',
  'forgot.sendError': 'No se pudo enviar el código de restablecimiento.',
  'forgot.confirmSubtitle': 'Introduce el código de tu correo y elige una nueva contraseña.',
  'forgot.code': 'Código de verificación',
  'forgot.newPassword': 'Nueva contraseña',
  'forgot.update': 'Actualizar contraseña',
  'forgot.updateError': 'No se pudo restablecer la contraseña.',
  'forgot.doneSubtitle': 'Tu contraseña se ha actualizado. Ya puedes iniciar sesión.',
  'forgot.backToSignIn': 'Volver al inicio de sesión',
};
